import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { App as CapacitorApp } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

/**
 * Hook to handle Android hardware back button
 * Makes it behave like browser back button instead of minimizing the app
 */
export const useAndroidBackButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Only run on Android native platform
    if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== 'android') {
      return;
    }

    // Routes where back button should exit the app
    const exitRoutes = ['/', '/home', '/survey', '/user-mode'];

    let listenerHandle: any;

    const setupListener = async () => {
      listenerHandle = await CapacitorApp.addListener('backButton', ({ canGoBack }) => {
        // If on exit route and can't go back, exit the app
        if (exitRoutes.includes(location.pathname) && !canGoBack) {
          CapacitorApp.exitApp();
        } 
        // If can go back, navigate back in history
        else if (canGoBack) {
          navigate(-1);
        }
        // Otherwise, exit the app
        else {
          CapacitorApp.exitApp();
        }
      });
    };

    setupListener();

    // Cleanup listener on unmount
    return () => {
      if (listenerHandle) {
        listenerHandle.remove();
      }
    };
  }, [navigate, location.pathname]);
};

export default useAndroidBackButton;
